module.exports = __webpack_public_path__ + "static/media/mozart.1afd5bd0.jpg";